import { render } from "./Loadingbar.vue?vue&type=template&id=2251522f&scoped=true"
import script from "./Loadingbar.vue?vue&type=script&lang=js"
export * from "./Loadingbar.vue?vue&type=script&lang=js"

import "./Loadingbar.vue?vue&type=style&index=0&id=2251522f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2251522f"]])

export default __exports__